import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Switch, FormControlLabel } from '@mui/material';
import { authFetch } from '../utils/api';
import { guardWrite } from '../utils/permissions';

const API = process.env.REACT_APP_API_BASE_URL;

export default function WixKnowledgePreferences({ botId, children }) {
  const { t } = useTranslation();
  const [value, setValue] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    setValue(null); setError(false);
    authFetch(`${API}apps/wix/knowledge_preferences?bot_id=${encodeURIComponent(botId)}`)
      .then(async r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(data => { if (active) setValue(data); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [botId]);
  const toggle = async (key, enabled) => {
    if (busy || !guardWrite()) return;
    setBusy(true); setError(false);
    try {
      const r = await authFetch(`${API}apps/wix/knowledge_preferences?bot_id=${encodeURIComponent(botId)}`, {
        method: 'PUT', body: JSON.stringify({ [key]: enabled }),
      });
      if (!r.ok) throw new Error();
      setValue(await r.json());
    } catch { setError(true); }
    finally { setBusy(false); }
  };
  if (children) return <section className="wix-knowledge-cards" aria-busy={busy}>
    {children({ value, busy, toggle })}
    {error && <p role="alert">{t('wxo_sources_save_error')}</p>}
  </section>;
  return <section className="wix-knowledge-preferences" aria-busy={busy}>
    <strong>{t('wxo_knowledge_sources')}</strong>
    <div>
      {['products', 'cms'].map(source => <FormControlLabel key={source}
        control={<Switch checked={Boolean(value?.[`${source}_enabled`])} disabled={!value || busy}
          onChange={(_, enabled) => toggle(`${source}_enabled`, enabled)} />}
        label={t(source === 'products' ? 'skill_flow_wix_products_label' : 'skill_flow_wix_cms_label')} />)}
    </div>
    {error && <p role="alert">{t('wxo_sources_save_error')}</p>}
  </section>;
}
